import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const err = (e) => e.response?.data?.detail || e.message;

export function PackCheck({ r, reload }) {
  const [open, setOpen] = useState(false);
  const [serial, setSerial] = useState("");
  const [label, setLabel] = useState("");
  const [res, setRes] = useState(r.pack_check);
  const check = async () => {
    try { const { data } = await api.post(`/quote-fulfilment/shipments/${r.shipment_id}/pack-check`, { serial, label }); setRes(data); toast[data.result === "MATCH" ? "success" : "error"](data.message); setSerial(""); setLabel(""); reload(); }
    catch (e) { toast.error(err(e)); }
  };
  const tone = res?.result === "MATCH" ? "bg-emerald-600 text-white" : res?.result === "MISMATCH" ? "bg-rose-600 text-white" : "";
  return (
    <div className="min-w-[170px] space-y-1" data-testid={`fd-pack-${r.allocation_id}`}>
      {res && <div className={`rounded px-1.5 py-0.5 text-[10px] font-bold ${tone}`} data-testid={`fd-pack-result-${r.allocation_id}`} title={res.detail}>{res.result === "MATCH" ? "MATCH ✓" : "LABEL MISMATCH — DO NOT PACK"}</div>}
      {!open ? <button onClick={() => setOpen(true)} className="rounded border border-slate-300 bg-white px-1.5 py-0.5 text-[10px] font-semibold hover:bg-slate-50" data-testid={`fd-pack-open-${r.allocation_id}`}>Pack check</button> : (
        <div className="space-y-1">
          <input autoFocus value={serial} onChange={(e) => setSerial(e.target.value)} placeholder="1 · Scan device serial" className="h-7 w-full rounded border border-slate-300 px-1.5 font-mono text-[10px]" data-testid={`fd-pack-serial-${r.allocation_id}`} />
          <input value={label} onChange={(e) => setLabel(e.target.value)} onKeyDown={(e) => e.key === "Enter" && label && check()} placeholder="2 · Scan welcome label QR" className="h-7 w-full rounded border border-slate-300 px-1.5 font-mono text-[10px]" data-testid={`fd-pack-label-${r.allocation_id}`} />
          <button onClick={check} disabled={!label} className="w-full rounded bg-slate-900 px-1.5 py-1 text-[10px] font-semibold text-white disabled:opacity-40" data-testid={`fd-pack-submit-${r.allocation_id}`}>Validate</button>
        </div>)}
    </div>
  );
}
